var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28438 21.3333H24.7164C24.2604 20.548 24.0004 19.6373 24.0004 18.6667V12C24.0004 7.58801 20.411 4.00001 16.0004 4.00001C11.5884 4.00001 8.00038 7.58801 8.00038 12V18.6667C8.00038 19.6373 7.73905 20.548 7.28438 21.3333ZM29.3339 24H2.6672C1.92986 24 1.33386 23.404 1.33386 22.6667C1.33386 21.9293 1.92986 21.3333 2.6672 21.3333C4.13786 21.3333 5.33386 20.1373 5.33386 18.6667V12C5.33386 6.11868 10.1179 1.33334 16.0005 1.33334C21.8819 1.33334 26.6672 6.11868 26.6672 12V18.6667C26.6672 20.1373 27.8632 21.3333 29.3339 21.3333C30.0699 21.3333 30.6672 21.9293 30.6672 22.6667C30.6672 23.404 30.0699 24 29.3339 24ZM15.9923 30.66C15.3123 30.66 14.623 30.4867 13.9937 30.1227C13.391 29.772 12.8883 29.2694 12.539 28.668C12.171 28.0307 12.3883 27.2147 13.0243 26.8467C13.6643 26.4747 14.4777 26.6947 14.847 27.332C14.963 27.5307 15.1297 27.6987 15.331 27.8147C15.967 28.1867 16.7843 27.9654 17.1537 27.3307C17.5243 26.6947 18.3403 26.4787 18.9763 26.848C19.6137 27.2174 19.831 28.032 19.459 28.6694C18.719 29.9467 17.3737 30.66 15.9923 30.66Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/ring-icon.391b6242db293d2cf3034ffd468a59ae.svg";
export { ForwardRef as ReactComponent };